import { Pipe, PipeTransform, Injectable } from '@angular/core';
import { TimePeriodAggregationType } from '../constants/time-period-aggregation-type';
import { TimePeriodRecentPerformance } from '../constants/time-periods-recent-performance';

@Pipe({ name: 'convertTimePeriodToInterval' })
@Injectable({ providedIn: 'root' })
export class ConvertTimePeriodToIntervalPipe implements PipeTransform {
    transform(timePeriod: string): number {
        switch (timePeriod) {
            case TimePeriodRecentPerformance.Current:
                return 1;
            case TimePeriodRecentPerformance.Last7Days:
                return 7;
            case TimePeriodRecentPerformance.Last30Days:
                return 30;
            case TimePeriodAggregationType.Weekly:
                return 7;
            case TimePeriodAggregationType.Monthly:
                return 30;
            case TimePeriodAggregationType.Quarterly:
                return 90;
            case TimePeriodAggregationType.Yearly:
                return 365;
        }

        return 7;
    }
}
